module.exports = __webpack_public_path__ + "./fonts/BrandonText-SemiBold.otf";